import { render, staticRenderFns } from "./UserConfirmEmail.vue?vue&type=template&id=036b2978&scoped=true"
import script from "./UserConfirmEmail.vue?vue&type=script&lang=js"
export * from "./UserConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./UserConfirmEmail.vue?vue&type=style&index=0&id=036b2978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b2978",
  null
  
)

export default component.exports